'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	validEmail = require('@mindmup/js-utils/src/valid-email');

require('./section-handler-widget');
require('./show-error');
require('./show-progress-message');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.emailAuthenticationWidget = function (emailIdentityProvider) {
	const ENTER = 13;
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			emailField = widget.find('input[name=gold-account-identifier]'),
			sendEmailButton = widget.find('[data-mm-role~="send-email"]'),
			confirmButton = widget.find('[data-mm-role~="confirm-one-time-code"]'),
			oneTimeCodeField = widget.find('input[name=gold-account-one-time-code]'),
			showError = function (reason) {
				widget.showError(reason);
			},
			validatedOnetimeCode = () => {
				const oneTimeCode = oneTimeCodeField.val().trim();
				if (!oneTimeCode) {
					confirmButton.addClass('disabled');
					oneTimeCodeField.addClass('validation-error');
					return;
				}
				confirmButton.removeClass('disabled');
				oneTimeCodeField.removeClass('validation-error');
				return oneTimeCode;
			},
			authenticateIdentity = function () {
				const oneTimeCode = validatedOnetimeCode();
				if (!oneTimeCode) {
					return;
				}
				widget.showProgressMessage('Signing in, please wait...');
				emailIdentityProvider.authenticate(oneTimeCode).then(function () {
					trackEvent({
						action: 'login',
						method: 'email'
					});
					widget.addClass('hidden');
				}, showError);
			},
			validatedEmail = () => {
				const email = emailField.val().trim();
				if (!validEmail(email)) {
					sendEmailButton.addClass('disabled');
					emailField.addClass('validation-error');
					return;
				}
				sendEmailButton.removeClass('disabled');
				emailField.removeClass('validation-error');
				return email;
			},
			sendEmail = function () {
				const email = validatedEmail();
				if (!email) {
					return;
				}
				widget.showProgressMessage('Signing in, please wait...');
				emailIdentityProvider.requestOneTimePassword(email).then(function () {
					confirmButton.addClass('disabled');
					oneTimeCodeField.val('');
					widget.showSection('enter-one-time-code');
				}, showError);
			};
		emailField.on('input', validatedEmail);
		oneTimeCodeField.on('input', validatedOnetimeCode);

		emailField.on('keydown', function (e) {
			if (e.keyCode === ENTER) {
				sendEmail();
			}
		});
		oneTimeCodeField.on('keydown', function (e) {
			if (e.keyCode === ENTER) {
				authenticateIdentity();
			}
		});
		widget.on('show', function () {
			oneTimeCodeField.val('');
			oneTimeCodeField.removeClass('validation-error');
			widget.showSection('not-authenticated');
			validatedEmail();
			emailField.removeClass('validation-error');
		});
		sendEmailButton.click(sendEmail);

		confirmButton.click(authenticateIdentity);
	});
};
